<template>
    <div>
        <div v-show="error">
            <div class="bg-danger alert status-box" >
                {{error}}
            </div>
        </div>

        <div v-show="!processing && !success">
            <textarea class="form-control" v-model="entered_addresses" rows="8" placeholder="Enter addresses one per line"></textarea>
            <br />
            <button class="btn btn-primary" @click="verifyAddresses">Verify Addresses</button>
        </div>
        <div v-show="processing">
            <div class="loading-bar">
                <div class="loaded" :style="{width: loadedAmt}"></div>
                <div class="loading-track"></div>
            </div>
            <span class="loading-text">
                {{loaded_index}} of {{unverified_addresses.length}} addresses processed
            </span>

            <div v-show="check_addresses.length" class="container-fluid">

                <div class="row entered_address">
                    <div class="col">
                        <strong>Multiple Addresses found at this location:</strong><br />
                        Entered Address:  {{ unverified_addresses[loaded_index] }}
                    </div>
                </div>
                <div class="row">
                   <div class="col">Matched Addresses:</div>
                </div>
                <div class="row lined matched_address " v-for="a in check_addresses">
                    <div class="col-8">{{a.formatted_address}}</div>
                    <div class="col-4 text-right">
                        <button class="btn btn-sm btn-light" @click="setAddress(a)">Use this address</button>
                    </div>
                </div>




            </div>

            <div class="row">
                <div class="col">
                    <button v-show="check_addresses.length" class="btn btn-sm btn-light" @click="moveNext">Skip This Address</button>
                    <button class="btn btn-sm btn-light" @click="clearAddresses">Cancel Import</button>

                </div>
            </div>

            <grid-loader v-show="searching" class="loader-element" color="#5e9cd3" size="12px"></grid-loader>

        </div>

        <div v-show="success" class="success">
            {{success}} <button class="btn btn-light btn-sm float-right" @click="clearAddresses"><i class="fa fa-remove"></i> Clear Addresses</button>
        </div>

    </div>
</template>
<script type="text/babel">

    import GridLoader from 'vue-spinner/src/GridLoader.vue'
    export default {
        name: "GoogleAddressSearcher",
        data() {
            return {
                display_address: '',
                entered_addresses: '',
                unverified_addresses: [],
                loaded_index: 0,
                check_addresses: [],
                addressList: [],
                address: {
                    address: '',
                    city: '',
                    state: '',
                    zip: '',
                    lat:'',
                    lng:'',
                    neighborhood: '',
                    formatted_address: ''
                },
                error_addresses: [],
                processing: false,
                searching: false,
                success: null,
                error: '',
            }
        },
        components:{
            GridLoader
        },
        computed:{
            addresses(){
                return this.addressList.map(function (address) {
                    return address.formatted_address;
                })
            },
            loadedAmt(){
                if(this.loaded_index <= 0) return 0;
                return ( this.loaded_index *  ( 100 / this.unverified_addresses.length)) + '%';
            }
        },
        created(){
            this.map = new window.TCMap();

        },
        methods:{
            verifyAddresses(){
                this.entered_addresses = this.entered_addresses.trim();
                this.unverified_addresses = this.entered_addresses.split("\n");

                if(!this.unverified_addresses){
                    this.error = 'Please enter some addresses';
                    return;
                }

                this.processing = true;
                this.searchGoogle();

            },
            checkAddressSet(){
                if(!this.address.lat && !this.address.lng){
                    this.clearAddress();
                }



            },

            clearAddresses(){
                this.searching = false;
                this.addressList = [];
                this.loaded_index = 0;
                this.success = null;
            },
            searchGoogle: _.debounce(
                    function() {
                        var _this = this;
                        if(!_this.unverified_addresses[_this.loaded_index]) {
                            this.processing = false;
                            this.success = "Processed " + _this.addressList.length + " addresses.";
                            this.$emit('input', this.addressList)
                        };


                        var address = _this.unverified_addresses[_this.loaded_index];
                        _this.searching = true;

                        this.map.search(address, function (err, data) {

                            if (err) {
                                console.error(err);
                                console.log(data);
                                _this.error_addresses.push(address)
                            } else {
                                console.log(data);
                                if(data && data.length === 1){
                                    _this.setAddress(data[0]);
                                } else if(data && data.length > 1){
                                    _this.searching = false;
                                    _this.check_addresses = data;
                                } else {
                                    _this.error_addresses.push(address);

                                }

                            }
                        })
                    }, 500),
            setAddress(address){

                var foundAddress = {
                    address: '',
                    city: '',
                    state: '',
                    zip: '',
                    lat:'',
                    lng:'',
                    neighborhood: '',
                    formatted_address: ''
                };

                address.address_components.map(ac => {
                    if(ac.types.indexOf('street_number') > -1 ) foundAddress.address += ac.short_name;
                    if(ac.types.indexOf('route') > -1 ) foundAddress.address += ac.short_name;
                    if(ac.types.indexOf('neighborhood') > -1 ) foundAddress.neighborhood += ac.short_name;
                    if(ac.types.indexOf('locality') > -1 ) foundAddress.city += ac.short_name;
                    if(ac.types.indexOf('administrative_area_level_1') > -1 ) foundAddress.state += ac.short_name;
                    if(ac.types.indexOf('postal_code') > -1 ) foundAddress.zip += ac.short_name;
                });

                foundAddress.formatted_address = address.formatted_address;
                foundAddress.lat = address.geometry.location.lat();
                foundAddress.lng = address.geometry.location.lng();


                this.addressList.push(foundAddress);
                this.moveNext();



            },
            skipAddress(address){
                this.error_addresses.push(address);
                this.moveNext();
            },
            moveNext(){
                this.check_addresses = [];
                this.loaded_index++;
                this.searchGoogle();
            }
        },
        props:['selected'],

    }
</script>

<style scoped>
    .loading-bar {
        display: block;
        position: relative;
        width: 100%;
        height: 10px;
    }
    .loading-track {
        position: absolute;
        background-color: #f0f0f0;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        border-radius: 2px;
        z-index:0;
        height: 100%;
        width: 100%;
    }
    .loaded {
        position: absolute;
        background-color: #5e9cd3;
        top: 0;
        left: 0;
        bottom: 0;
        width: 0%;
        height: 100%;
        border-radius: 2px;
        z-index:10;
    }

    .loader-element{
        margin: 10px auto;
    }
    span.loading-text {
        text-align: right;
        display: block;
        font-size: 12px;
    }


</style>


// WEBPACK FOOTER //
// GoogleMultipleAddressSearcher.vue?79bccfd0